import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { activeTab } from "../../../assets";
import { BORROWED, CLAIMABLE, IN_INVENTORY } from "../../../constants";
import { tokens } from "../../../theme";

export const StatusTab = ({ currStatus, setCurrStatus }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        width: "100%",
        borderBottom: "2px solid #E8ECF5",
        display: "flex",
        flexDirection: "row",
        paddingLeft: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginRight: "20px",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
        onClick={() => setCurrStatus(IN_INVENTORY)}
      >
        <Typography variant="fs13" fontWeight={500} color={colors.black[200]}>
          Owned
        </Typography>

        <img
          src={activeTab}
          alt={"active"}
          style={{
            width: "64px",
            height: "10px",
            visibility: currStatus === IN_INVENTORY ? "visible" : "hidden",
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginRight: "20px",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
        onClick={() => setCurrStatus(BORROWED)}
      >
        <Typography variant="fs13" fontWeight={500} color={colors.black[200]}>
          Borrowed
        </Typography>
        <img
          src={activeTab}
          alt={"active"}
          style={{
            width: "64px",
            height: "10px",
            visibility: currStatus === BORROWED ? "visible" : "hidden",
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginRight: "20px",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
        onClick={() => setCurrStatus(CLAIMABLE)}
      >
        <Typography variant="fs13" fontWeight={500} color={colors.black[200]}>
          Claimable
        </Typography>
        <img
          src={activeTab}
          alt={"active"}
          style={{
            width: "64px",
            height: "10px",
            visibility: currStatus === CLAIMABLE ? "visible" : "hidden",
          }}
        />
      </Box>
    </Box>
  );
};
